import {atom} from 'jotai'

export const gMeniAtom = atom([])